// extracted by mini-css-extract-plugin
export var container = "_1c-0";
export var disabled = "_1c-4";
export var fullWidth = "_1c-3";
export var lined = "_1c-1";
export var selected = "_1c-5";
export var tab = "_1c-2";